import {sortBy, reverse, merge} from 'lodash';
import {monochromeColors} from '@js/modules/public/infographics/helpers/color';
import getDefaultChartSettings from '@js/modules/public/infographics/helpers/chartsSettings';

export default function initCountryUnionPieChart(stat, countryIdsInSelectedUnion, selectedCountryId) {
    const rawChartData = stat
        .filter(({id}) => countryIdsInSelectedUnion.includes(parseInt(id, 10)));
    let countOrganizations = 0;
    rawChartData.forEach((item) => {
        countOrganizations += parseInt(item.count, 10);
    });
    let data = rawChartData
        .map(({name_en: name, count, id: countryId}) => {
            const selected = parseInt(countryId, 10) === parseInt(selectedCountryId, 10);
            const percentage = count ? (parseInt(count, 10) / countOrganizations) * 100 : 0;
            const series = {
                sliced: selected,
                name,
                y: percentage,
            };
            if (selected) {
                series.color = '#178ea4';
            }
            return series;
        });
    data = sortBy(data, 'y');
    const colors = reverse(monochromeColors(data.length));
    const defaultPieSettings = getDefaultChartSettings();
    const pieSettings = merge(defaultPieSettings, {
        accessibility: {
            point: {
                valueSuffix: '%',
            },
        },
        plotOptions: {
            pie: {
                colors,
                dataLabels: {
                    enabled: true,
                    format: '{point.name}: {point.y:.1f}%',
                },
            },
        },
        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b><br/>',
        },
        series: [
            {
                name: 'Удельный вес страны в глобальном агрегированном рейтинге',
                colorByPoint: true,
                type: 'pie',
                innerSize: '40%',
                data,
                dataLabels: {
                    enabled: true,
                },
            },
        ],
    });
    return Highcharts.chart('piePresenceCountryOnUnionInRanking', pieSettings);
}
